import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class WorkOrderStatusBadge extends Component {

    constructor(props, context) {
        super(props, context);
        this.status = this.props.status
        this.className = this.props.className || ''
        this.customStyle = this.props.style || {}
    }

    renderStatus() {
        switch (this.status) {
            case 'new':
                return <div className="badge badge-primary text-with-icon">
                    <FormattedMessage
                        id="work_order.status.new_label"
                        defaultMessage="New"
                    />
                </div>
            case 'cancelled':
                return <div className="badge badge-light text-with-icon">
                    <FormattedMessage
                        id="work_order.status.cancelled_label"
                        defaultMessage="Cancelled"
                    />
                </div>
            case 'completed':
                return <div className="badge badge-info text-with-icon">
                    <FormattedMessage
                        id="work_order.status.completed_label"
                        defaultMessage="Completed"
                    />
                </div>
            case 'approved':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="work_order.status.approved_label"
                        defaultMessage="Approved"
                    />
                </div>
            case 'revised':
                return <div className="badge badge-success text-with-icon">
                    <FormattedMessage
                        id="work_order.status.revised_label"
                        defaultMessage="Revised"
                    />
                </div>
        }
        return <div></div>
    }

    render() {
        return <span className={this.className} style={this.customStyle}>
            {this.renderStatus()}
        </span>
    }

}

export default WorkOrderStatusBadge





// WEBPACK FOOTER //
// ./src/workorder/status.component.jsx